import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://nblfyqocyvofxkmxkliq.supabase.co";
const SUPABASE_ANON_KEY = "sb_publishable_NtUsgDMwCahcY3UFv7uc5g_H83gEVQD";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);